import React from 'react';
interface AdvertorialCTAProps {
  headline: string;
  subheadline: string;
  productImage: string;
  price: string;
  originalPrice: string;
  buttonText: string;
  buttonLink: string;
  guarantee: string;
}
export const AdvertorialCTA: React.FC<AdvertorialCTAProps> = ({
  headline,
  subheadline,
  productImage,
  price,
  originalPrice,
  buttonText,
  buttonLink,
  guarantee
}) => {
  return <section className="w-full py-12 md:py-20 bg-blue-100" data-id="element-13">
      <div className="container mx-auto px-4" data-id="element-14">
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl p-6 md:p-10" data-id="element-15">
          <h2 className="text-2xl md:text-4xl font-bold text-blue-900 mb-6 text-center" data-id="element-16">
            {headline}
          </h2>
          {subheadline && <p className="text-xl md:text-2xl text-blue-700 mb-8 text-center" data-id="element-17">
              {subheadline}
            </p>}
          <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-18">
            <div className="w-full md:w-1/2" data-id="element-19">
              
            </div>
            <div className="w-full md:w-1/2 flex flex-col items-center md:items-start" data-id="element-20">
              <ul className="space-y-3 mb-6 text-left w-full" data-id="element-21">
                <li className="text-lg md:text-xl text-gray-700 flex items-start" data-id="element-22">
                  <span className="text-green-600 mr-2" data-id="element-23">✓</span>
                  <span data-id="element-24">100% Naturliga ingredienser</span>
                </li>
                <li className="text-lg md:text-xl text-gray-700 flex items-start" data-id="element-25">
                  <span className="text-green-600 mr-2" data-id="element-26">✓</span>
                  <span data-id="element-27">{guarantee}</span>
                </li>
                <li className="text-lg md:text-xl text-gray-700 flex items-start" data-id="element-28">
                  <span className="text-green-600 mr-2" data-id="element-29">✓</span>
                  <span data-id="element-30">Få en gåva helt gratis på köpet</span>
                </li>
              </ul>
              {price && <div className="flex items-center mb-4" data-id="element-31">
                  <span className="text-3xl md:text-4xl font-bold text-blue-900" data-id="element-32">
                    {price}
                  </span>
                  {originalPrice && <span className="ml-3 text-xl text-gray-500 line-through" data-id="element-33">
                      {originalPrice}
                    </span>}
                </div>}
              <a href={buttonLink} className="w-full px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-bold text-lg md:text-xl rounded-lg transition-colors duration-200 text-center" data-id="element-34">
                {buttonText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};